module.exports = __webpack_public_path__ + "img/actv.eae90da4.svg";